export default [
  // Cadastro/edição de formas e prazos desabilitado temporariamente
  // {
  //   name:"CreatePaymentOption",
  //   path:"/payment_options/create",
  //   meta: { 
  //     auth: true,
  //     roles: ["Director"],
  //   },
  //   component: () => import("@/_backoffice/_registrations/components/payment_option/CreatePaymentOption.vue")
  // },
  // {
  //   name:"CreatePayDue",
  //   path:"/pay_due/create",
  //   meta: { 
  //     auth: true,
  //     roles: ["Director"],
  //   },
  //   component: () => import("@/_backoffice/_registrations/components/payment_option/CreatePayDue.vue")
  // },
  {
    name:"PaymentOptions",
    path:"/payment_options",
    meta: { 
      auth: true,
      roles: ["Director"],
    },
    component: () => import("@/_backoffice/_registrations/pages/PaymentOptions.vue"),
    // children:[
    //   {
    //     name:"EditPaymentOption",
    //     path:"/payment_options/:id",
    //     meta: { 
    //       auth: true,
    //       roles: ["Director"],
    //     },
    //     component: () => import("@/_backoffice/_registrations/components/payment_option/EditPaymentOption.vue")
    //   },
    //   {
    //     name:"EditPayDue",
    //     path:"/pay_due/:id",
    //     meta: { 
    //       auth: true,
    //       roles: ["Director"],
    //     },
    //     component: () => import("@/_backoffice/_registrations/components/payment_option/EditPayDue.vue")
    //   },
    // ]
  },



]